import controller from './routines-detail.controller';
import template from './routines-detail.view.html';

let RoutinesDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<',
	id : '=',
	rut : '<'
  }
};

export default RoutinesDetailComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-detail/routines-detail.component.js
 **/